
// shared:
//
export const LOAD_SCENE = 'LOAD_SCENE';
export const ADD_NODE = 'ADDNODE';
export const ADD_VR_CAMERA = 'ADD_VR_CAMERA';
export const SET_VR_CAMERA = 'SET_VR_CAMERA';
export const DELETE_NODE = 'DELETE_NODE';
export const LOADING_FILE = 'LOADING_FILE';
export const LOADED_FILE = 'LOADED_FILE';
export const LOADING_FILE_ERROR = 'LOADING_FILE_ERROR';
export const CLEAR_SCENE = 'CLEAR_SCENE';



// WEBPACK FOOTER //
// ./src/modules/actionTypes.js